import React from 'react';
import { CardTitle, Link } from '@one-thd/sui-atomic-components';
import { Orders } from '@one-thd/sui-icons';
import PropTypes from 'prop-types';
import { showAboveSmBreakpointIf, quoteCardTitleStyles } from '../../constants/responsiveClassNames';
import { useQuoteContext } from '../../hooks/useQuoteContext';
import { triggerAnalyticsCustomEvent } from '../../utils/analyticsEvents';

const QuotesHeader = ({ hideActionLink }) => {
  const { loading, error, hasQuotes } = useQuoteContext();

  if (loading || error) return null;

  const viewAllQuotesClick = () => {
    triggerAnalyticsCustomEvent('quotes.stash-click', {
      component: 'view all'
    });
  };

  return (
    <CardTitle
      header={(
        <div className="sui-flex sui-gap-3 sui-items-center">
          <Orders /><h4 className={quoteCardTitleStyles}>Quotes</h4>
        </div>
      )}
      actionPosition="end"
      action={hideActionLink ? null : (
        <div className={`${showAboveSmBreakpointIf(hasQuotes)} sui-pb-4`}>
          <Link onClick={viewAllQuotesClick} href="/quote/list">View All Quotes</Link>
        </div>
      )}
    />
  );
};

QuotesHeader.propTypes = {
  hideActionLink: PropTypes.bool,
};
QuotesHeader.defaultProps = {
  hideActionLink: false,
};

export default QuotesHeader;
